import {pushGTMInternal} from "../integrations/tracking/gtm/pushGtmEvents";
import * as mutationTypes from "../store/mutation-types";
import { formatPriceZero } from "../domains2/libraries/Utils";
import { getCategories } from "./CatalogHelper";
import {cloneDeep} from "lodash";

function getPriceDiffAfterUpgrade(self) {
	const baseProductSelectionId = self.$store.getters.productSelectionIdToRemove[0];
	const originalProductSelection = self.$store.getters.cartProducts.find(ps => ps.productSelectionId === baseProductSelectionId);
	if(!originalProductSelection) return undefined;
	const singleMainProductIdsToMenuIdsMap = self.$store.getters.singleMainProductIdsToMenuIdsMap;
	const singleToMenuMapItem = singleMainProductIdsToMenuIdsMap && singleMainProductIdsToMenuIdsMap[originalProductSelection.productId];
	return singleToMenuMapItem && singleToMenuMapItem.price - originalProductSelection.price;
}

const UpgradeToMenuFromBasket = Object.freeze({
	resetFlag: (self) => {
		self.$store.commit(mutationTypes.SET_UPGRADE_TO_MENU_FROM_BASKET_FLAG, false);
		self.$store.commit(mutationTypes.SET_PRODUCT_SELECTION_TO_REMOVE, []);
	},
	handleStateOnClosing: (self) => {
		if (self.$store.getters.upgradeToMenuFromBasketFlag) {
			const priceDiff = getPriceDiffAfterUpgrade(self);
			pushGTMInternal(
				"UpgradeBasket",
				self.product.name,
				self.$route.path,
				"",
				{
					email: (self.$store.getters.getUserData || {}).email,
					selectedRestaurant: (self.globalSelectedShop || {}).shopName,
					upsellValue: priceDiff
				}
			);
		}
		const ids = self.$store.getters.productSelectionIdToRemove;
		if (ids.length) {
			self.$store.commit(mutationTypes.REMOVE_FROM_CART_BULK, {productSelections: ids.map(psId => ({productSelectionId: psId}))});
		}
	},
	goToCatalog: (self) => {
		const categories = getCategories(
			self.productCatalog.getCategories(),
			self.$store.getters.channelAlias,
			self.$store.getters.globalSelectedShop.id
		);
		const menuCat = categories.find(x=>x.categoryType === "MENU");
		self.$router.push(
			`/category/${menuCat.extId}?upgradeToMenuProductId=${self.product.id}&productSelectionToRemove=${self.productSelection.productSelectionId}`
		);
	},
	priceDiff: (self) => {
		const menuPrice = self.$store.getters.singleMainProductIdsToMenuIdsMap[self.product.id].price;
		const diff = menuPrice - self.orderLine.price;
		return diff > 0 ? "+"+formatPriceZero(diff) : "";
	},
	upgradeCartState: (self, value) => {
		const singleMainProductIdsToMenuIdsMap = value.reduce((acc, curr) => {
			const mainGroup = curr.product.groups.find(g => g.options.groupType === "main");
			if (mainGroup && mainGroup.products && mainGroup.products[0]) {
				acc[mainGroup.products[0].id] = {};
				const temp = acc[mainGroup.products[0].id];
				temp.id = curr.product.id;
				temp.price = curr.productPrice.discountPrice;
			}
			return acc;
		}, {});
		self.$store.commit(mutationTypes.SET_SINGLE_MAIN_PRODUCT_ID_TO_MENU_PRODUCT_ID_MAP, singleMainProductIdsToMenuIdsMap);
	},
	copyProductSelectionsFromBurgerToMenu: (self, selections) => {
		if (selections && selections.length > 0) {
			const productSelectionIdsFromCart = self.$store.getters.cartProducts.map(ps => ps.productSelectionId);
			const filteredProductSelections = selections.find(selection => !productSelectionIdsFromCart.includes(selection.productSelectionId));
			const baseProductSelectionId = self.$store.getters.productSelectionIdToRemove[0];
			const originalProductSelection = self.$store.getters.cartProducts.find(ps => ps.productSelectionId === baseProductSelectionId);
			if(!originalProductSelection) return undefined;
			const copyProductSelections = cloneDeep(originalProductSelection);
			if(filteredProductSelections) {
				filteredProductSelections.groups[0].selectedProducts[0].groups = copyProductSelections.groups;
				if(filteredProductSelections.groups[0].selectedProducts[0].configurations.length > 0) {
					filteredProductSelections.groups[0].selectedProducts[0].configurations[0].selectedValue = copyProductSelections.configurations[0].selectedValue;
				}
			}
		}
	}
});

export default UpgradeToMenuFromBasket;
